/*eslint-disable */
import {
  bus
} from '../../main';
var jQuery = window.jQuery = require('jquery');
export default {
  name: 'game_header',
  components: {},
  props: [],
  data() {
    return {
      isLoggin: ''
    }
  },
  computed: {},

  mounted() {},
  methods: {
    goToHome() {
      this.$router.push('/')
      jQuery("body").removeClass("quizzort_popup_active");
    },
    handleScroll() {
      let header = document.querySelector(".header_fix_games");
      let body = document.querySelector("body");
      if (window.scrollY > 10 && !header.className.includes('sticky')) {
        header.classList.add('sticky');
        body.classList.add('has-sticy-nav');
      } else if (window.scrollY < 10) {
        header.classList.remove('sticky');
        body.classList.remove('has-sticy-nav');
      }
    },
    togglePopupFunction() {
      this.$router.push('/#games');
    }
  },
  updated() {

  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
    let body = document.querySelector("body");
    body.classList.remove('has-sticy-nav');
  },
  watch: {}
}